<!-- 孩子属性 孩子四书 -->
<template>
  <div class="TableContent TableContents_3">
    <p class="setctionTitle">属性</p>
    <ul class="DataListStyle clear">
      
      <template v-for="(a, a_index) in attr" :key="a_index">
        <!-- 力、体、敏、疾、魂、念 -->
        <li class="li_k3">{{ a.text }}：</li>
        <li class="li3">{{ child_effect[a.key] || 0 }}</li>
      </template>

      <li class="li_k3 margin1">攻击：</li>
      <li class="li3 margin1">
        {{ child_effect['pmin'] }}-{{ child_effect['pmax'] }}
      </li>
      <li class="li_k2 margin1">法力：</li>
      <li class="li2 margin1">
        {{ child_effect['mmin'] }}-{{ child_effect['mmax'] }}
      </li>
      <li class="li_k3">命中：</li>
      <li class="li3">{{ child_effect['hit'] }}</li>
      <li class="li_k2">重击：</li>
      <li class="li2">{{ child_effect_count['modadd'] }}</li>
      <li class="li_k3 hx">会心一击：</li>
      <li class="li3 yj">{{ child_effect['cri'] }}</li>
      <li class="li_k2 hx">附加伤害：</li>
      <li class="li2 yj">{{ child_effect_count['attadd'] }}</li>
      <li class="li_k3">防御：</li>
      <li class="li3">{{ child_effect['pdef'] }}</li>
      <li class="li_k2">法防：</li>
      <li class="li2">{{ child_effect['mdef'] }}</li>
      <li class="li_k3">回避：</li>
      <li class="li3">{{ child_effect['avoid'] }}</li>
      <li class="li_k2">化解：</li>
      <li class="li2">{{ child_effect_count['attdef'] }}</li>
      <li class="li_k3">身法：</li>
      <li class="li3">{{ child_effect['sdact'] }}</li>
      <li class="li_k2">定力：</li>
      <li class="li2">{{ child_effect['sdmd'] }}</li>
      <li class="li_k3">坚韧：</li>
      <li class="li3">{{ child_effect['sdbd'] }}</li>
      <li class="li_k2">御心：</li>
      <li class="li2">{{ child_effect['cri_sub_p_child'] }}</li>
      <li class="li_k3">诛心：</li>
      <li class="li3">{{ child_effect['cri_add_p_child'] }}</li>
      <li class="li_k2">万钧：</li>
      <li class="li2">{{ child_effect['thump_add_p_child'] }}</li>
    </ul>

    <p class="setctionTitle mt-15">四书</p>
    <ul class="DataListStyle sishu-list clear">
      <li class="li_k3 hx">天书等级：</li>
      <li class="li1 auto">
        {{ child.fourbooks_lv }}
      </li>
      <li class="li_k3">破阵：</li>
      <li class="li3">
        {{ fb_comb_props['absolutely_attack_without_modify'] }}
      </li>
      <li class="li_k2">磐石：</li>
      <li class="li2">
        {{ fb_comb_props['absolutely_defence_without_modify'] }}
      </li>
      <li class="li_k3">破甲：</li>
      <li class="li3">
        {{ fb_comb_props['ignore_pdef'] }}
      </li>
      <li class="li_k2">透魔：</li>
      <li class="li2">
        {{ fb_comb_props['ignore_mdef'] }}
      </li>
      <li class="li_k3">身法：</li>
      <li class="li3">
        {{ fb_comb_props['sdact'] }}
      </li>
      <li class="li_k2">坚韧：</li>
      <li class="li2">
        {{ fb_comb_props['sdbd'] }}
      </li>
      <li class="li_k3">资质：</li>
      <li class="li3">
        {{ fb_comb_props['potential'] }}
      </li>
    </ul>
    <ul class="DataListStyle sishu-list clear">
      <li class="li_k3 hx">经始参悟：</li>
      <li class="li1 auto">
        {{ child['fourbooks_point'] }}
      </li>
    </ul>

    <div class="fourbooks-com">
      <commonItem
        :content="one.content || ''"
        v-for="(one, i) in one_child.fourbooks"
        :key="i"
        :src="fourbook_img(one['name'].split('·')[1])"
      >
        <template v-slot:title>
          <span class="tooltip_title tooltip_title_color">
            {{ one.name }}
          </span>
        </template>
      </commonItem>
    </div>
  </div>
</template>

<script setup>
const { attr } = inject('Game');

const {
  child_tskill_img,
  child_pskill_img,
  child_sex_img,
  item_img,
  child_wing_img,
  res_img,
  fourbook_img,
} = inject('filters');

const props = defineProps({
  one_child: {
    type: Object,
    default: () => ({}),
  },
});

const child_effect = computed(() => {
  return props.one_child?.child?.child_effect || {};
});

const fb_comb_props = computed(() => {
  return props.one_child?.child?.fb_comb_props || {};
});
const child_effect_count = computed(() => {
  return props.one_child?.child_effect_count || {};
});

const child = computed(() => {
  return props.one_child?.child || {};
});
</script>

<style lang="scss" scoped>
.fourbooks-com {
  display: flex;
  gap: 16px;
}
</style>